import { SnackAlertaComponent } from './../../components/globales/snack-alerta/snack-alerta.component';
import { snackAlerta } from './../../interfaces/snackAlerta';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable()
export class SnackService {
  constructor(private snack: MatSnackBar) {}

  openSnackAlert(
    time: number,
    snackDatos: snackAlerta,
    horizontalPosition: MatSnackBarHorizontalPosition,
    verticalPosition: MatSnackBarVerticalPosition
  ) {
    return this.snack.openFromComponent(SnackAlertaComponent, {
      data: snackDatos,
      duration: time,
      panelClass: ['theme-snackbar'],
      horizontalPosition,
      verticalPosition,
    });
  }
}
